import { render, staticRenderFns } from "./DataPerformanceStandmansFromSurvey.vue?vue&type=template&id=582b7e46&scoped=true&"
import script from "./DataPerformanceStandmansFromSurvey.vue?vue&type=script&lang=ts&"
export * from "./DataPerformanceStandmansFromSurvey.vue?vue&type=script&lang=ts&"
import style0 from "./DataPerformanceStandmansFromSurvey.vue?vue&type=style&index=0&id=582b7e46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b7e46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VSimpleTable})
